import React from "react";
import { Controller } from "react-hook-form";
import { Box, FormHelperText, FormLabel, TextField as MuiTextField } from "@material-ui/core";
import classnames from "classnames";

import { withShowIf } from "../../../../components/with-show-if/with-show-If.component";

import { FieldToggle } from "../../components/field-toggle/field-toggle.component";

import { SubTitle, useFieldsStyles } from "../fields.styles";

import { TextFieldProps } from "./text-field.props";

export const TextField = withShowIf((props: TextFieldProps) => {
  const {
    inputPattern = "",
    rows = 10,
    size = "medium",
    variant = "outlined",
    withAdd = false,
  } = props;

  const commonClasses = useFieldsStyles();

  const hasError = !!props.form.formState.errors[props.name];
  const errorMessage = props.form.formState.errors[props.name]?.message;
  const canEdit = Boolean(props.userPermissions?.canEdit) || Boolean(props.noAuthRequired);

  const wrapperClasses = classnames({
    [commonClasses.fieldWrapper]: true,
    [commonClasses.hidden]: props.hidden,
  });

  const onNumericChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const value: string = event.target.value;
    const float = parseFloat(value);

    return {
      ...event,
      target: {
        ...event.target,
        value: value === "" || isNaN(float) ? "" : float.toString(),
      },
    };
  };

  const onChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    if (props.numeric) {
      return onNumericChange(event);
    }

    const value: string = event.target.value;
    if (inputPattern !== "" && !value.match(inputPattern)) {
      event.target.value = props.form.getValues(props.name);
    }

    return event;
  };

  const placeholder = () =>
    props.numeric && !props.placeholder ? "Number Only" : props.placeholder;

  return (
    <Controller
      control={props.form.control}
      name={`${props.name}` as const}
      render={(renderProps) => (
        <div className={wrapperClasses}>
          {props.label && (
            <Box display="flex" justifyContent="space-between">
              <FormLabel htmlFor={props.name} error={hasError} required={props.required}>
                {props.label}
              </FormLabel>
              <SubTitle showIf={!!props.subTitle}>{props.subTitle}</SubTitle>
            </Box>
          )}

          <FieldToggle
            addButtonText={props.addButtonText}
            canEdit={canEdit}
            name={props.name}
            openByDefault={String(renderProps.field.value) !== ""}
            setValue={props.form.setValue!}
            use={withAdd}
          >
            <MuiTextField
              {...{ ...renderProps.field, ref: undefined }}
              disabled={props.disabled || !canEdit}
              error={hasError}
              fullWidth
              inputRef={renderProps.field.ref}
              id={props.name}
              multiline={props.multiline}
              onChange={(event) => renderProps.field.onChange(onChange(event))}
              placeholder={placeholder()}
              rows={rows}
              size={size}
              variant={variant}
            />
          </FieldToggle>
          {hasError && <FormHelperText error={hasError}>{errorMessage}</FormHelperText>}
        </div>
      )}
    />
  );
});
